import React, { useEffect, useState } from "react";
import { Card, CardContent, Table, TableBody, TableCell, TableContainer, TableRow, TablePagination } from "@mui/material";
import { usePermissions, useRedirect } from "react-admin";
import authProvider from "./authProvider";

const PAGE_SIZE = 10; // 1ページの表示行数

const LogView = () => {

  const [lines, setLines] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE);
  const redirect = useRedirect();
  
  useEffect(() => {
    if(authProvider){
      authProvider
      .checkAuth()
      .then(() => {})
      .catch(() => {
        redirect("/login")
      });
    }
  }, [authProvider]);
 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/logText`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setLines(data);
      } catch (error) {
        console.error("ファイルの読み込みに失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, []);

  // ページ変更時の処理
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // 1ページの表示行数変更時の処理
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // ページ番号をリセット
  };

  // 表示するデータを slice() で分割
  const paginatedLines = lines.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const {permissions} = usePermissions();
  if(permissions < 1){
    return;
  }

  return (
    <>
    {/* ページネーションの追加 */}
    <TablePagination
      rowsPerPageOptions={[5, 10, 20, 100]}
      component="div"
      count={lines.length} // 総行数
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      labelRowsPerPage="1ページあたりの行数:"
      labelDisplayedRows={({ from, to, count }) => `${from}〜${to}件目 / 全${count}件`}
    />
    <Card sx={{padding: 3 }}>
      <CardContent>
        <TableContainer>
          <Table>
            <TableBody>
              {paginatedLines.map((line, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: line.includes("ERROR") ? "#ffdddd" : "transparent", // "Error" を含む行を赤色に
                    color: line.includes("ERROR") ? "red" : "inherit",
                  }}
                >
                  <TableCell>{line}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
    {/* ページネーションの追加 */}
    <TablePagination
      rowsPerPageOptions={[5, 10, 50, 100]}
      component="div"
      count={lines.length} // 総行数
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      labelRowsPerPage="1ページあたりの行数:"
      labelDisplayedRows={({ from, to, count }) => `${from}〜${to}件目 / 全${count}件`}
    />
    </>
  );
};

export default LogView;
